//Smoothscroll also with page change reload, jumps to top and scrolls down again

const scrollDuration = 500;

//switch off in development, when browser sync is on
if(document.getElementById('__bs_script__') === null){
    // to top right away
    if ( window.location.hash )scroll(0,0);
    // void some browsers issue
    setTimeout( function() {
        scroll(0, 0);
    }, 50);

    window.addEventListener('load', function () {
        let offsetTop = 0;
        setTimeout(function () {
            if (window.location.hash) {
                // smooth scroll to the anchor id
                offsetTop = $(window.location.hash).offset().top;
            } else if (location.search.includes('q=') === true) {
                // if job search param is set, scroll to form or wrapping container
                let formContentElement = $('.content-main .suggestSearch').parents('.frame-container');
                let offsetElement = formContentElement;
                if (formContentElement.parents('.frame-type-wst3bootstrap_container').length > 0) {
                    offsetElement = formContentElement.parents('.frame-type-wst3bootstrap_container');
                }
                offsetTop = offsetElement.offset().top;
            }

            if (offsetTop > 0) {
                // remove navbar from scroll position
                offsetTop -= $('.main-navbar').height();
                $('html, body').animate({
                    scrollTop: offsetTop + 'px'
                }, scrollDuration);
            }
        }, 50);
    });
}

//smoothscroll for links with hash
$(function() {
    //@fixme avoid to kill standard bs4 functionality like collapse elements
    $('a:not([data-toggle="collapse"]):not([role="tab"])').on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Store hash
            var hash = this.hash;
            var offsetTop = $(hash).offset().top;
            offsetTop -= $('.main-navbar').height();
            // Using jQuery's animate() method to add smooth page scroll
            $('html, body').animate({
                scrollTop: offsetTop
            }, scrollDuration, function() {
                // Add hash (#) to URL when done scrolling (default click behavior)
                if (history.pushState) {
                    // IE10, Firefox, Chrome, etc.
                    window.history.pushState(null, null, hash);
                }else{
                    window.location.hash = hash;
                }
            });
            return false;
        } // End if
    });

    $('.job-search-form button.btn-primary').on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Store hash
            var offsetTop = $(this).parents('form').offset().top;
            offsetTop -= $('.main-navbar').height();
            // Using jQuery's animate() method to add smooth page scroll
            $('html, body').animate({
                scrollTop: offsetTop
            }, scrollDuration);
            return false;
        } // End if
    });
});